import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { PackageRoutingModule } from './package-routing.module'
import { AddPackageComponent } from './pages/add-package/add-package.component'

import { AddPackageInfoComponent } from './components/add-package-info/add-package-info.component'
import { AddPackageDurationComponent } from './components/add-package-duration/add-package-duration.component'
import { AddPackageServicesComponent } from './components/add-package-services/add-package-services.component'
import { AddViewPackageServiceComponent } from './components/add-view-package-service/add-view-package-service.component'
import { PackagesListComponent } from './pages/packages-list/packages-list.component'
import { PackagesTableComponent } from './components/packages-table/packages-table.component'
import { SharedModule } from 'src/app/shared/shared.module'
import {
	MAT_MOMENT_DATE_ADAPTER_OPTIONS,
	MatMomentDateModule,
} from '@angular/material-moment-adapter'
@NgModule({
	declarations: [
		AddPackageComponent,

		AddPackageInfoComponent,
		AddPackageDurationComponent,
		AddPackageServicesComponent,
		AddViewPackageServiceComponent,
		PackagesListComponent,
		PackagesTableComponent,
	],
	imports: [
		CommonModule,
		PackageRoutingModule,
		SharedModule,
		MatMomentDateModule,
	],
	exports: [],
	providers: [
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
	],
})
export class PackageModule {}
